import { Typography } from "@joonapp/web-shared"

import FiveStars from "../../components/fiveStars/FiveStars"

const ReferralTestimonialCard = ({
  testimonial,
  inCarousel = false,
  isOnboarding = false,
}: {
  testimonial: {
    text: string
    image: string
    quotee: string
  }
  inCarousel?: boolean
  isOnboarding?: boolean
}) => {
  const { text, image, quotee } = testimonial
  return (
    <div
      key={quotee}
      className={`w-[250px] flex flex-col items-center justify-between gap-2 bg-white rounded-lg p-4 border border-borderPrimary shadow-md ${
        inCarousel ? "mx-auto h-[250px]" : "h-[300px]"
      }`}
    >
      <div className="flex flex-row items-start gap-2">
        {isOnboarding && <Typography variant="bodyBold">4.7</Typography>}
        <FiveStars size={20} />
      </div>
      {isOnboarding && (
        <Typography variant="bodySmallBold">
          Trusted by 500k+ families!
        </Typography>
      )}
      <Typography variant="bodySmall">{text}</Typography>
      <div className="flex flex-col items-center justify-start gap-2">
        <img
          src={image}
          alt={text}
          className="w-9 h-9 rounded-full"
          style={{
            pointerEvents: "none",
            userSelect: "none",
          }}
        />
        <Typography variant="bodyXSmallBold">
          {quotee}
          {isOnboarding && ", parent of child with ADHD"}
        </Typography>
      </div>
    </div>
  )
}

export default ReferralTestimonialCard
